export default {
  // Basic pages
  'pages.layouts.userLayout.title': 'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage': 'Umi ui is now released, welcome to use npm run ui to start the experience.',

  // Search table
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules': 'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled Time',
  'pages.searchTable.updatedAt': 'Last Updated',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Operating',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.update': 'Update',
  'pages.searchTable.clone': 'Clone',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Query Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Batch Deletion',
  'pages.searchTable.batchApproval': 'Batch Approval',
  'pages.searchTable.delete': 'Delete',
  'pages.searchTable.print': 'Print',

  // Common
  'pages.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.delete.ok': 'Delete',
  'pages.delete.cancel': 'Cancel',
  'pages.common.noPermission': 'You do not have permission to perform this operation',
  'common.yes': 'Yes',
  'common.no': 'No',

  // Query Filter Labels
  'pages.queryFilter.label.customerId': 'Customer ID',
  'pages.queryFilter.label.supplierId': 'Supplier ID',
  'pages.queryFilter.label.productId': 'Product ID',
  'pages.queryFilter.label.code': 'Code',
  'pages.queryFilter.label.sourceType': 'Source Type',
  'pages.queryFilter.label.status': 'Status',
  'pages.queryFilter.label.inspectionType': 'Inspection Type',
  'pages.queryFilter.label.requestedAtFrom': 'Requested At From',
  'pages.queryFilter.label.requestedAtTo': 'Requested At To',
  'pages.queryFilter.label.targetDateFrom': 'Target Date From',
  'pages.queryFilter.label.targetDateTo': 'Target Date To',

  // Source Transaction
  'pages.sourceTransaction.title': 'Source Transaction Detail',
  'pages.sourceTransaction.code': 'Code',
  'pages.sourceTransaction.date': 'Date',
  'pages.sourceTransaction.sourceType': 'Source Type',
  'pages.sourceTransaction.customerName': 'Customer',
  'pages.sourceTransaction.customerId': 'Customer',
  'pages.sourceTransaction.supplierName': 'Supplier',
  'pages.sourceTransaction.supplierId': 'Supplier',
  'pages.sourceTransaction.productName': 'Product',
  'pages.sourceTransaction.productId': 'Product',
  'pages.sourceTransaction.uomId': 'Unit of Measure',
  'pages.sourceTransaction.uomName': 'UOM',
  'pages.sourceTransaction.colorName': 'Color',
  'pages.sourceTransaction.colorId': 'Color',
  'pages.sourceTransaction.sizeName': 'Size',
  'pages.sourceTransaction.sizeId': 'Size',
  'pages.sourceTransaction.destinationName': 'Destination',
  'pages.sourceTransaction.destinationId': 'Destination',
  'pages.sourceTransaction.operationLibraryDetailName': 'Operation Library Detail',
  'pages.sourceTransaction.operationLibraryDetailId': 'Operation Library Detail',
  'pages.sourceTransaction.quantity': 'Quantity',
  'pages.sourceTransaction.orderQuantity': 'Order Quantity',
  'pages.sourceTransaction.offeredQuantity': 'Offered Quantity',
  'pages.sourceTransaction.fiDate': 'FI Date',
  'pages.sourceTransaction.updatedAt': 'Updated At',
  'pages.sourceTransaction.actions': 'Actions',
  'pages.sourceTransaction.create': 'Create',
  'pages.sourceTransaction.update': 'Update',
  'pages.sourceTransaction.cancel': 'Cancel',
  'pages.sourceTransaction.close': 'Close',
  'pages.sourceTransaction.details': 'Details',
  'pages.sourceTransaction.createForm.title': 'New Source Transaction',
  'pages.sourceTransaction.updateForm.title': 'Update Source Transaction',
  'pages.sourceTransaction.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.sourceTransaction.delete.ok': 'Delete',
  'pages.sourceTransaction.delete.cancel': 'Cancel',
  'pages.sourceTransaction.categoryName': 'Category',
  'pages.sourceTransaction.productGroupName': 'Product Group',
  'pages.sourceTransaction.subCategoryName': 'Sub Category',
  'pages.sourceTransaction.countryName': 'Country',
  'pages.sourceTransaction.marketName': 'Market',
  'pages.sourceTransaction.merge': 'Merge',
  'pages.sourceTransaction.remainIQCOfferedQuantity': 'Remain IQC Offered Quantity',
  'pages.sourceTransaction.remainInlineOfferedQuantity': 'Remain Inline Offered Quantity',
  'pages.sourceTransaction.remainPreFinalOfferedQuantity': 'Remain Pre-Final Offered Quantity',
  'pages.sourceTransaction.remainFinalOfferedQuantity': 'Remain Final Offered Quantity',

  // QC Definition
  'pages.qcDefinition.title': 'QC Definition Detail',
  'pages.qcDefinition.code': 'Code',
  'pages.qcDefinition.name': 'Name',
  'pages.qcDefinition.type': 'Type',
  'pages.qcDefinition.type.placeholder': 'Select Type',
  'pages.qcDefinition.status': 'Status',
  'pages.qcDefinition.status.placeholder': 'Select Status',
  'pages.qcDefinition.status.saved': 'Save',
  'pages.qcDefinition.status.pending': 'Pending',
  'pages.qcDefinition.status.confirmed': 'Confirm',
  'pages.qcDefinition.product': 'Product',
  'pages.qcDefinition.product.placeholder': 'Select Product',
  'pages.qcDefinition.productGroup': 'Product Group',
  'pages.qcDefinition.productGroup.placeholder': 'Select Product Group',
  'pages.qcDefinition.category': 'Category',
  'pages.qcDefinition.category.placeholder': 'Select Category',
  'pages.qcDefinition.customer': 'Customer',
  'pages.qcDefinition.customer.placeholder': 'Select Customer',
  'pages.qcDefinition.supplier': 'Supplier',
  'pages.qcDefinition.supplier.placeholder': 'Select Supplier',
  'pages.qcDefinition.process': 'Operation Library Detail', 
  'pages.qcDefinition.process.placeholder': 'Select Operation Library Detail',
  'pages.qcDefinition.country': 'Country',
  'pages.qcDefinition.country.placeholder': 'Select Country',
  'pages.qcDefinition.destination': 'Destination',
  'pages.qcDefinition.destination.placeholder': 'Select Destination',
  'pages.qcDefinition.market': 'Market',
  'pages.qcDefinition.market.placeholder': 'Select Market',
  'pages.qcDefinition.defectConversion': 'Defect Conversion',
  'pages.qcDefinition.isActive': 'Active',
  'pages.qcDefinition.updatedAt': 'Updated At',
  'pages.qcDefinition.actions': 'Actions',
  'pages.qcDefinition.create': 'Create',
  'pages.qcDefinition.update': 'Update',
  'pages.qcDefinition.cancel': 'Cancel',
  'pages.qcDefinition.close': 'Close',
  'pages.qcDefinition.details': 'Details',
  'pages.qcDefinition.createForm.title': 'New QC Definition',
  'pages.qcDefinition.updateForm.title': 'Update QC Definition',
  'pages.qcDefinition.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.qcDefinition.delete.ok': 'Delete',
  'pages.qcDefinition.delete.cancel': 'Cancel',
  'pages.qcDefinition.inspectionType': 'Inspection Type',
  'pages.qcDefinition.inspectionType.placeholder': 'Select Inspection Type',
  'pages.qcDefinition.qcDefinitionType': 'QC Definition Type',
  'pages.qcDefinition.qcDefinitionType.placeholder': 'Select QC Definition Type',
  'pages.qcDefinition.judgementType': 'Judgement Type',
  'pages.qcDefinition.judgementType.placeholder': 'Select Judgement Type',
  'pages.qcDefinition.value': 'Value',
  'pages.qcDefinition.value.placeholder': 'Enter Value',

  // Defect Group
  'pages.defectGroup.title': 'Defect Group Detail',
  'pages.defectGroup.code': 'Code',
  'pages.defectGroup.name': 'Name',
  'pages.defectGroup.isActive': 'Active',
  'pages.defectGroup.updatedAt': 'Updated At',
  'pages.defectGroup.actions': 'Actions',
  'pages.defectGroup.create': 'Create',
  'pages.defectGroup.update': 'Update',
  'pages.defectGroup.cancel': 'Cancel',
  'pages.defectGroup.close': 'Close',
  'pages.defectGroup.details': 'Details',
  'pages.defectGroup.createForm.title': 'New Defect Group',
  'pages.defectGroup.updateForm.title': 'Update Defect Group',
  'pages.defectGroup.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.defectGroup.delete.ok': 'Delete',
  'pages.defectGroup.delete.cancel': 'Cancel',

  // Defect Action
  'pages.defectAction.title': 'Defect Action Detail',
  'pages.defectAction.code': 'Code',
  'pages.defectAction.name': 'Name',
  'pages.defectAction.type': 'Type',
  'pages.defectAction.isActive': 'Active',
  'pages.defectAction.description': 'Description',
  'pages.defectAction.organizationDetailId': 'Organization Detail',
  'pages.defectAction.employeeId': 'Employee',
  'pages.defectAction.updatedAt': 'Updated At',
  'pages.defectAction.actions': 'Actions',
  'pages.defectAction.create': 'Create',
  'pages.defectAction.update': 'Update',
  'pages.defectAction.cancel': 'Cancel',
  'pages.defectAction.close': 'Close',
  'pages.defectAction.details': 'Details',
  'pages.defectAction.createForm.title': 'New Defect Action',
  'pages.defectAction.updateForm.title': 'Update Defect Action',
  'pages.defectAction.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.defectAction.delete.ok': 'Delete',
  'pages.defectAction.delete.cancel': 'Cancel',

  // Defect Reason
  'pages.defectReason.title': 'Defect Reason Detail',
  'pages.defectReason.code': 'Code',
  'pages.defectReason.name': 'Name',
  'pages.defectReason.isActive': 'Active',
  'pages.defectReason.updatedAt': 'Updated At',
  'pages.defectReason.actions': 'Actions',
  'pages.defectReason.create': 'Create',
  'pages.defectReason.update': 'Update',
  'pages.defectReason.cancel': 'Cancel',
  'pages.defectReason.close': 'Close',
  'pages.defectReason.details': 'Details',
  'pages.defectReason.createForm.title': 'New Defect Reason',
  'pages.defectReason.updateForm.title': 'Update Defect Reason',
  'pages.defectReason.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.defectReason.delete.ok': 'Delete',
  'pages.defectReason.delete.cancel': 'Cancel',

  // Defect Conversion
  'pages.defectConversion.title': 'Defect Conversion Detail',
  'pages.defectConversion.code': 'Code',
  'pages.defectConversion.name': 'Name',
  'pages.defectConversion.conversionUnit': 'Conversion Unit',
  'pages.defectConversion.majorConversion': 'Major Conversion',
  'pages.defectConversion.minorConversion': 'Minor Conversion',
  'pages.defectConversion.isActive': 'Active',
  'pages.defectConversion.updatedAt': 'Updated At',
  'pages.defectConversion.actions': 'Actions',
  'pages.defectConversion.create': 'Create',
  'pages.defectConversion.update': 'Update',
  'pages.defectConversion.cancel': 'Cancel',
  'pages.defectConversion.close': 'Close',
  'pages.defectConversion.details': 'Details',
  'pages.defectConversion.createForm.title': 'New Defect Conversion',
  'pages.defectConversion.updateForm.title': 'Update Defect Conversion',
  'pages.defectConversion.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.defectConversion.delete.ok': 'Delete',
  'pages.defectConversion.delete.cancel': 'Cancel',

  // Report Template
  'pages.reportTemplate.title': 'Report Template Detail',
  'pages.reportTemplate.code': 'Code',
  'pages.reportTemplate.name': 'Name',
  'pages.reportTemplate.applicableTo': 'Applicable To',
  'pages.reportTemplate.reportType': 'Report Type',
  'pages.reportTemplate.outputFormat': 'Output Format',
  'pages.reportTemplate.templateKind': 'Template Kind',
  'pages.reportTemplate.url': 'URL',
  'pages.reportTemplate.metadataJson': 'Metadata JSON',
  'pages.reportTemplate.description': 'Description',
  'pages.reportTemplate.isActive': 'Active',
  'pages.reportTemplate.updatedAt': 'Updated At',
  'pages.reportTemplate.actions': 'Actions',
  'pages.reportTemplate.create': 'Create',
  'pages.reportTemplate.update': 'Update',
  'pages.reportTemplate.cancel': 'Cancel',
  'pages.reportTemplate.close': 'Close',
  'pages.reportTemplate.details': 'Details',
  'pages.reportTemplate.createForm.title': 'New Report Template',
  'pages.reportTemplate.updateForm.title': 'Update Report Template',
  'pages.reportTemplate.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.reportTemplate.delete.ok': 'Delete',
  'pages.reportTemplate.delete.cancel': 'Cancel',
  'pages.reportTemplate.upload': 'Upload File',
  'pages.reportTemplate.upload.success': 'File uploaded successfully',
  'pages.reportTemplate.upload.error': 'Upload failed',
  'pages.reportTemplate.upload.invalidWord': 'Please upload a Word file (.doc or .docx)',
  'pages.reportTemplate.upload.invalidExcel': 'Please upload an Excel file (.xls or .xlsx)',
  'pages.reportTemplate.currentUrl': 'Current URL',
  'pages.reportTemplate.url.required': 'URL is required. Please upload a file.',

  // Report Template - Docs
  'pages.reportTemplate.templateDesign': 'Template Design Guide',

  // Defect List
  'pages.defectList.title': 'Defect List Detail',
  'pages.defectList.code': 'Code',
  'pages.defectList.name': 'Name',
  'pages.defectList.isActive': 'Active',
  'pages.defectList.description': 'Description',
  'pages.defectList.category': 'Category',
  'pages.defectList.customer': 'Customer',
  'pages.defectList.process': 'Operation Library Detail',
  'pages.defectList.defectConversion': 'Defect Conversion',
  'pages.defectList.updatedAt': 'Updated At',
  'pages.defectList.actions': 'Actions',
  'pages.defectList.create': 'Create',
  'pages.defectList.update': 'Update',
  'pages.defectList.cancel': 'Cancel',
  'pages.defectList.close': 'Close',
  'pages.defectList.details': 'Details',
  'pages.defectList.createForm.title': 'New Defect List',
  'pages.defectList.updateForm.title': 'Update Defect List',
  'pages.defectList.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.defectList.delete.ok': 'Delete',
  'pages.defectList.delete.cancel': 'Cancel',
  'pages.defectList.detailsTable': 'Defect Details',
  'pages.defectList.detail.defect': 'Defect',
  'pages.defectList.detail.sequence': 'Sequence',
  'pages.defectList.detail.delete.confirm': 'Delete this item?',

  // Defect List tabs
  'pages.defectList.tabs.details': 'Details',
  'pages.defectList.tabs.conditions': 'Conditions',
  'pages.defectList.addDetail': 'Add Detail',

  // Defect
  'pages.defect.title': 'Defect Detail',
  'pages.defect.code': 'Code',
  'pages.defect.name': 'Name',
  'pages.defect.isActive': 'Active',
  'pages.defect.types': 'Types',
  'pages.defect.defectGroup': 'Defect Group',
  'pages.defect.description': 'Description',
  'pages.defect.organizationDetail': 'Organization Detail',
  'pages.defect.employee': 'Employee',
  'pages.defect.updatedAt': 'Updated At',
  'pages.defect.actions': 'Actions',
  'pages.defect.create': 'Create',
  'pages.defect.update': 'Update',
  'pages.defect.cancel': 'Cancel',
  'pages.defect.close': 'Close',
  'pages.defect.details': 'Details',
  'pages.defect.createForm.title': 'New Defect',
  'pages.defect.updateForm.title': 'Update Defect',
  'pages.defect.delete.confirm': 'Are you sure to delete?',
  'pages.defect.delete.ok': 'Delete',
  'pages.defect.delete.cancel': 'Cancel',
  'pages.defect.deleteConfirm': 'Delete this item?',
  
  // Defect tabs
  'pages.defect.tabs.reasons': 'Reasons',
  'pages.defect.tabs.actions': 'Actions',
  'pages.defect.tabs.files': 'Files',
  'pages.defect.tabs.languages': 'Languages',
  
  // Defect reasons
  'pages.defect.reasonsTable': 'Defect Reasons',
  'pages.defect.addReason': 'Add Reason',
  'pages.defect.reason.defectReason': 'Defect Reason',
  'pages.defect.reason.code': 'Reason Code',
  'pages.defect.reason.name': 'Reason Name',
  
  // Defect actions
  'pages.defect.actionsTable': 'Defect Actions',
  'pages.defect.addAction': 'Add Action',
  'pages.defect.action.defectAction': 'Defect Action',
  'pages.defect.action.type': 'Type',
  'pages.defect.action.code': 'Action Code',
  'pages.defect.action.name': 'Action Name',
  
  // Defect files
  'pages.defect.filesTable': 'Defect Files',
  'pages.defect.addFile': 'Add File',
  'pages.defect.file.name': 'Name',
  'pages.defect.file.type': 'Type',
  'pages.defect.file.url': 'URL',
  'pages.defect.file.description': 'Description',
  'pages.defect.file.view': 'View',
  'pages.defect.file.upload': 'Upload',
  
  // Defect languages
  'pages.defect.languagesTable': 'Defect Languages',
  'pages.defect.addLanguage': 'Add Language',
  'pages.defect.language.language': 'Language',
  'pages.defect.language.value': 'Value',
  'pages.defect.language.description': 'Description',

  // Inspection Request
  'pages.inspectionRequest.code': 'Code',
  'pages.inspectionRequest.sourceType': 'Source Type',
  'pages.inspectionRequest.status': 'Status',
  'pages.inspectionRequest.inspectionType': 'Inspection Type',
  'pages.inspectionRequest.company': 'Company',
  'pages.inspectionRequest.site': 'Site',
  'pages.inspectionRequest.qcDefinition': 'QC Definition',
  'pages.inspectionRequest.checklist': 'Checklist',
  'pages.inspectionRequest.defectList': 'Defect List',
  'pages.inspectionRequest.targetDate': 'Target Date',
  'pages.inspectionRequest.scheduleDate': 'Schedule Date',
  'pages.inspectionRequest.employee': 'Employee',
  'pages.inspectionRequest.reason': 'Reason',
  'pages.inspectionRequest.createdBy': 'Created By',
  'pages.inspectionRequest.createdAt': 'Created At',
  'pages.inspectionRequest.updatedAt': 'Updated At',
  'pages.inspectionRequest.actions': 'Actions',
  'pages.inspectionRequest.create': 'Create',
  'pages.inspectionRequest.update': 'Update',
  'pages.inspectionRequest.delete': 'Delete',
  'pages.inspectionRequest.cancel': 'Cancel',
  'pages.inspectionRequest.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.inspectionRequest.createForm.title': 'New Inspection Request',
  'pages.inspectionRequest.updateForm.title': 'Update Inspection Request',
  'pages.inspectionRequest.details': 'Details',
  'pages.inspectionRequest.placeholder.sourceType': 'Select source type',
  'pages.inspectionRequest.placeholder.status': 'Select status',
  'pages.inspectionRequest.placeholder.inspectionType': 'Select inspection type',
  'pages.inspectionRequest.placeholder.company': 'Select company',
  'pages.inspectionRequest.placeholder.site': 'Select site',
  'pages.inspectionRequest.placeholder.qcDefinition': 'Select QC definition',
  'pages.inspectionRequest.placeholder.checklist': 'Select checklist',
  'pages.inspectionRequest.placeholder.defectList': 'Select defect list',
  'pages.inspectionRequest.placeholder.employee': 'Select employee',
  'pages.inspectionRequest.placeholder.scheduleDate': 'Select schedule date',
  'pages.inspectionRequest.placeholder.targetDate': 'Select target date',
  'pages.inspectionRequest.placeholder.reason': 'Enter reason',
  'pages.inspectionRequest.targetDate.required': 'Target Date is required',
  'pages.inspectionRequest.detailsTable': 'Inspection Request Details',
  'pages.inspectionRequest.detail.sourceTransaction': 'Source Transaction',
  'pages.inspectionRequest.detail.inspectedQuantity': 'Inspected Quantity',
  'pages.inspectionRequest.equivalentAcceptLimit': 'equivalent Accept Limit',
  'pages.inspectionRequest.majorAcceptLimit': 'Major Accept Limit',
  'pages.inspectionRequest.minorAcceptLimit': 'Minor Accept Limit',
  'pages.inspectionRequest.judgementType': 'Judgement Type',
  'pages.inspectionRequest.detail.placeholder.sourceTransaction': 'Select source transaction',
  'pages.inspectionRequest.detail.placeholder.inspectedQuantity': 'Enter quantity',
  'pages.inspectionRequest.detail.delete.confirm': 'Delete this item?',
  'pages.inspectionRequest.detail.duplicateWarning': 'This Source Transaction is already added!',
  'pages.inspectionRequest.detail.duplicateError': 'Cannot submit with duplicate Source Transactions. Please remove duplicates.',
  'pages.inspectionRequest.detail.duplicateAlert': 'Duplicate Source Transactions detected',
  'pages.inspectionRequest.detail.duplicateAlertDescription': 'Please ensure each Source Transaction is only added once. Remove duplicate entries before submitting.',
  
  // Bulk actions
  'pages.inspectionRequest.assign': 'Assign',
  'pages.inspectionRequest.assign.title': 'Assign Inspection Request(s)',
  'pages.inspectionRequest.assign.ok': 'Assign',
  'pages.inspectionRequest.employee.required': 'Please select employee',
  'pages.inspectionRequest.scheduleDate.required': 'Please select schedule date',
  'pages.inspectionRequest.status.cancelled': 'Cancelled',
  'pages.inspectionRequest.status.bypass': 'By Pass',
  'pages.inspectionRequest.status.inProgress': 'In Progress',
  'pages.inspectionRequest.status.reason.required': 'Please enter reason',
  'pages.inspectionRequest.status.reason.label': 'Reason (required):',
  'pages.inspectionRequest.status.reason.placeholder': 'Enter reason for status change',
  'pages.inspectionRequest.status..title': 'Change Status',
  'pages.inspectionRequest.status.saved.title': 'Change Status to Saved',
  'pages.inspectionRequest.status.confirmed.title': 'Change Status to Confirmed',
  'pages.inspectionRequest.status.inprogress.title': 'Change Status to In Progress',
  'pages.inspectionRequest.status.cancelled.title': 'Change Status to Cancelled',
  'pages.inspectionRequest.status.bypass.title': 'Change Status to By Pass',
  'pages.inspectionRequest.status.completed.title': 'Change Status to Completed',
  'pages.inspectionRequest.drawer.add': 'Add Inspection Request',
  'pages.inspectionRequest.drawer.update': 'Update Inspection Request',
  'pages.inspectionRequest.save': 'Save',
  'pages.inspectionRequest.selectSourceTransaction': 'Select Source Transaction',
  'pages.inspectionRequest.addSelected': 'Add Selected ({count})',
  'pages.inspectionRequest.addSelectedMerge': 'Add Selected Merge ({count})',
  'pages.inspectionRequest.selected': 'Selected {count} items',
  'pages.inspectionRequest.delete.record.confirm': 'Are you sure you want to delete this record?',

  // Inspection Request Coordinator (same as inspectionRequest)
  'pages.inspectionRequestCoordinator.code': 'Code',
  'pages.inspectionRequestCoordinator.sourceType': 'Source Type',
  'pages.inspectionRequestCoordinator.status': 'Status',
  'pages.inspectionRequestCoordinator.inspectionType': 'Inspection Type',
  'pages.inspectionRequestCoordinator.company': 'Company',
  'pages.inspectionRequestCoordinator.companyId': 'Company',
  'pages.inspectionRequestCoordinator.site': 'Site',
  'pages.inspectionRequestCoordinator.siteId': 'Site',
  'pages.inspectionRequestCoordinator.qcDefinition': 'QC Definition',
  'pages.inspectionRequestCoordinator.qcDefinitionId': 'QC Definition',
  'pages.inspectionRequestCoordinator.checklist': 'Checklist',
  'pages.inspectionRequestCoordinator.checklistId': 'Checklist',
  'pages.inspectionRequestCoordinator.defectList': 'Defect List',
  'pages.inspectionRequestCoordinator.defectListId': 'Defect List',
  'pages.inspectionRequestCoordinator.targetDate': 'Target Date',
  'pages.inspectionRequestCoordinator.scheduleDate': 'Schedule Date',
  'pages.inspectionRequestCoordinator.employee': 'Employee',
  'pages.inspectionRequestCoordinator.employeeId': 'Employee',
  'pages.inspectionRequestCoordinator.reason': 'Reason',
  'pages.inspectionRequestCoordinator.sourceTransaction': 'Source Transaction',
  'pages.inspectionRequestCoordinator.sourceTransactionId': 'Source Transaction',
  'pages.inspectionRequestCoordinator.productCode': 'Product Code',
  'pages.inspectionRequestCoordinator.productId': 'Product',
  'pages.inspectionRequestCoordinator.orderQuantity': 'Order Quantity',
  'pages.inspectionRequestCoordinator.offeredQuantity': 'Offered Quantity',
  'pages.inspectionRequestCoordinator.inspectedQuantity': 'Inspected Quantity',
  'pages.inspectionRequestCoordinator.equilaventAcceptLimit': 'Equivalent Accept Limit',
  'pages.inspectionRequestCoordinator.equivalentAcceptLimit': 'Equivalent Accept Limit',
  'pages.inspectionRequestCoordinator.majorAcceptLimit': 'Major Accept Limit',
  'pages.inspectionRequestCoordinator.minorAcceptLimit': 'Minor Accept Limit',
  'pages.inspectionRequestCoordinator.judgementType': 'Judgement Type',
  'pages.inspectionRequestCoordinator.createdBy': 'Created By',
  'pages.inspectionRequestCoordinator.createdAt': 'Created At',
  'pages.inspectionRequestCoordinator.updatedAt': 'Updated At',
  'pages.inspectionRequestCoordinator.fiDate': 'FI Date',
  'pages.inspectionRequestCoordinator.actions': 'Actions',
  'pages.inspectionRequestCoordinator.details': 'Details',
  'pages.inspectionRequestCoordinator.process': 'Process',
  'pages.inspectionRequestCoordinator.processId': 'Process',
  'pages.inspectionRequestCoordinator.create': 'Add',
  'pages.inspectionRequestCoordinator.update': 'Update',
  'pages.inspectionRequestCoordinator.delete': 'Delete',
  'pages.inspectionRequestCoordinator.delete.confirm': 'Are you sure you want to delete the selected inspection request(s)?',
  'pages.inspectionRequestCoordinator.cancel': 'Cancel',
  'pages.inspectionRequestCoordinator.confirm': 'Confirm',
  'pages.inspectionRequestCoordinator.selected': 'Selected {count} items',
  'pages.inspectionRequestCoordinator.unselect': 'Unselect',
  'pages.inspectionRequestCoordinator.assign': 'Assign',
  'pages.inspectionRequestCoordinator.assign.title': 'Assign Inspection Request(s)',
  'pages.inspectionRequestCoordinator.assign.ok': 'Assign',
  'pages.inspectionRequestCoordinator.employee.required': 'Please select employee',
  'pages.inspectionRequestCoordinator.scheduleDate.required': 'Please select schedule date',
  'pages.inspectionRequestCoordinator.placeholder.employee': 'Select employee',
  'pages.inspectionRequestCoordinator.placeholder.scheduleDate': 'Select schedule date',
  'pages.inspectionRequestCoordinator.status.cancelled': 'Cancelled',
  'pages.inspectionRequestCoordinator.status.bypass': 'By Pass',
  'pages.inspectionRequestCoordinator.status.inProgress': 'Start',
  'pages.inspectionRequestCoordinator.status.reason.required': 'Please enter reason',
  'pages.inspectionRequestCoordinator.status.reason.label': 'Reason (required):',
  'pages.inspectionRequestCoordinator.status.reason.placeholder': 'Enter reason for status change',
  'pages.inspectionRequestCoordinator.status.change.title': 'Change Status',
  'pages.inspectionRequestCoordinator.status.cancelled.title': 'Change Status to Cancelled',
  'pages.inspectionRequestCoordinator.status.bypass.title': 'Change Status to By Pass',
  'pages.inspectionRequestCoordinator.status.inprogress.title': 'Change Status to In Progress',
  'pages.inspectionRequestCoordinator.status.saved.title': 'Change Status to Saved',
  'pages.inspectionRequestCoordinator.status.confirmed.title': 'Change Status to Confirmed',
  'pages.inspectionRequestCoordinator.status.completed.title': 'Change Status to Completed',
  'pages.inspectionRequestCoordinator.message.assign.success': 'Assigned {count} inspection request(s) successfully',
  'pages.inspectionRequestCoordinator.message.assign.failed': 'Assign failed, please try again!',
  'pages.inspectionRequestCoordinator.message.statusChange.success': 'Status changed to {status} for {count} inspection request(s) successfully',
  'pages.inspectionRequestCoordinator.message.statusChange.failed': 'Status change failed, please try again!',
  'pages.inspectionRequestCoordinator.message.delete.success': 'Deleted {count} inspection request(s) successfully',
  'pages.inspectionRequestCoordinator.message.delete.errors': 'Deletion Errors:',
  'pages.inspectionRequestCoordinator.message.delete.failed': 'Delete failed, please try again!',
  'pages.inspectionRequestCoordinator.tooltip.cannotDelete': 'Cannot delete records with different statuses',
  'pages.inspectionRequestCoordinator.drawer.add': 'Add Inspection Request',
  'pages.inspectionRequestCoordinator.drawer.update': 'Update Inspection Request',
  'pages.inspectionRequestCoordinator.save': 'Save',
  'pages.inspectionRequestCoordinator.delete.record.confirm': 'Are you sure you want to delete this record?',
  'pages.inspectionRequestCoordinator.placeholder.code': 'Enter code',
  'pages.inspectionRequestCoordinator.placeholder.sourceTransaction': 'Select source transaction',
  'pages.inspectionRequestCoordinator.placeholder.company': 'Select company',
  'pages.inspectionRequestCoordinator.placeholder.qcDefinition': 'Select QC definition',
  'pages.inspectionRequestCoordinator.validation.code.required': 'Code is required',
  'pages.inspectionRequestCoordinator.validation.sourceType.required': 'Source Type is required',
  'pages.inspectionRequestCoordinator.validation.inspectionType.required': 'Inspection Type is required',
  'pages.inspectionRequestCoordinator.validation.sourceTransaction.required': 'Source Transaction is required',
  'pages.inspectionRequestCoordinator.validation.company.required': 'Company is required',
  'pages.inspectionRequestCoordinator.validation.qcDefinition.required': 'QC Definition is required',
  'pages.inspectionRequestCoordinator.validation.scheduleDate.required': 'Schedule Date is required when status is Confirmed',
  'pages.inspectionRequestCoordinator.validation.employee.required': 'Employee is required when status is Confirmed',
  'pages.inspectionRequestCoordinator.message.noChanges': 'No changes to save',
  'pages.inspectionRequestCoordinator.message.save.success': 'Changes saved successfully',
  'pages.inspectionRequestCoordinator.message.save.failed': 'Failed to save changes. Please try again.',
  'pages.inspectionRequestCoordinator.message.validation.failed': 'Please fix validation errors before saving',
  'pages.inspectionRequestCoordinator.message.record.removed': 'Record removed successfully',
  'pages.inspectionRequestCoordinator.message.record.markedForDeletion': 'Record marked for deletion. Click Save to apply changes.',
  'pages.inspectionRequestCoordinator.message.rows.added': '{count} row(s) added. Start typing to fill in the details.',
  'pages.inspectionRequestCoordinator.message.mapping.failed': 'Failed to load mapping data. Please try again.',
  'pages.inspectionRequestCoordinator.loading.mapping': 'Loading mapping data and calculating quantities...',
  'pages.inspectionRequestCoordinator.copy.menu.all': 'Copy to all rows',
  'pages.inspectionRequestCoordinator.copy.menu.below': 'Copy to rows below',
  'pages.inspectionRequestCoordinator.copy.successAll': 'Copied value to {count} row(s).',
  'pages.inspectionRequestCoordinator.copy.successBelow': 'Copied value to {count} row(s) below.',
  'pages.inspectionRequestCoordinator.copy.noRowsAll': 'There are no rows available to copy.',
  'pages.inspectionRequestCoordinator.copy.noRowsBelow': 'There are no rows below to copy to.',

  // Inspection Request Inspector (same as inspectionRequest)
  'pages.inspectionRequestInspector.code': 'Code',
  'pages.inspectionRequestInspector.sourceType': 'Source Type',
  'pages.inspectionRequestInspector.status': 'Status',
  'pages.inspectionRequestInspector.inspectionType': 'Inspection Type',
  'pages.inspectionRequestInspector.company': 'Company',
  'pages.inspectionRequestInspector.companyId': 'Company',
  'pages.inspectionRequestInspector.site': 'Site',
  'pages.inspectionRequestInspector.siteId': 'Site',
  'pages.inspectionRequestInspector.qcDefinition': 'QC Definition',
  'pages.inspectionRequestInspector.qcDefinitionId': 'QC Definition',
  'pages.inspectionRequestInspector.checklistId': 'Checklist',
  'pages.inspectionRequestInspector.defectListId': 'Defect List',
  'pages.inspectionRequestInspector.sourceTransaction': 'Source Transaction',
  'pages.inspectionRequestInspector.sourceTransactionId': 'Source Transaction',
  'pages.inspectionRequestInspector.productCode': 'Product Code',
  'pages.inspectionRequestInspector.productId': 'Product',
  'pages.inspectionRequestInspector.inspectedQuantity': 'Inspected Quantity',
  'pages.inspectionRequestInspector.equivalentAcceptLimit': 'Equivalent Accept Limit',
  'pages.inspectionRequestInspector.equilaventAcceptLimit': 'Equivalent Accept Limit',
  'pages.inspectionRequestInspector.majorAcceptLimit': 'Major Accept Limit',
  'pages.inspectionRequestInspector.minorAcceptLimit': 'Minor Accept Limit',
  'pages.inspectionRequestInspector.judgementType': 'Judgement Type',
  'pages.inspectionRequestInspector.targetDate': 'Target Date',
  'pages.inspectionRequestInspector.scheduleDate': 'Schedule Date',
  'pages.inspectionRequestInspector.employee': 'Employee',
  'pages.inspectionRequestInspector.employeeId': 'Employee',
  'pages.inspectionRequestInspector.fiDate': 'FI Date',
  'pages.inspectionRequestInspector.updatedAt': 'Updated At',
  'pages.inspectionRequestInspector.selected': 'Selected {count} items',
  'pages.inspectionRequestInspector.unselect': 'Unselect',
  'pages.inspectionRequestInspector.status.cancelled': 'Cancelled',
  'pages.inspectionRequestInspector.status.bypass': 'By Pass',
  'pages.inspectionRequestInspector.status.inProgress': 'Start',
  'pages.inspectionRequestInspector.status.completed': 'Completed',
  'pages.inspectionRequestInspector.status.reason.required': 'Please enter reason',
  'pages.inspectionRequestInspector.status.reason.label': 'Reason (required):',
  'pages.inspectionRequestInspector.status.reason.placeholder': 'Enter reason for status change',
  'pages.inspectionRequestInspector.status.change.title': 'Change Status',
  'pages.inspectionRequestInspector.status.cancelled.title': 'Change Status to Cancelled',
  'pages.inspectionRequestInspector.status.bypass.title': 'Change Status to By Pass',

  // Inspection Result
  'pages.inspectionResult.title': 'Inspection Result Detail',
  'pages.inspectionResult.inspectionRequestCode': 'Request Code',
  'pages.inspectionResult.inspectionRequestEmployeeId': 'Employee',
  'pages.inspectionResult.productCode': 'Product Code',
  'pages.inspectionResult.productId': 'Product',
  'pages.inspectionResult.inspectionType': 'Inspection Type',
  'pages.inspectionResult.date': 'Date',
  'pages.inspectionResult.status': 'Status',
  'pages.inspectionResult.offeredCarton': 'Offered Carton',
  'pages.inspectionResult.inspectedCarton': 'Inspected Carton',
  'pages.inspectionResult.judgementStatus': 'Judgement Status',
  'pages.inspectionResult.judgementUserId': 'Judgement User',
  'pages.inspectionResult.judgementUserName': 'Judgement User',
  'pages.inspectionResult.judgementDate': 'Judgement Date',
  'pages.inspectionResult.updatedAt': 'Updated At',
  'pages.inspectionResult.actions': 'Actions',
  'pages.inspectionResult.update': 'Update',
  'pages.inspectionResult.cancel': 'Cancel',
  'pages.inspectionResult.close': 'Close',
  'pages.inspectionResult.details': 'Details',
  'pages.inspectionResult.updateForm.title': 'Update Inspection Result',
  'pages.inspectionResult.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.inspectionResult.delete.ok': 'Delete',
  'pages.inspectionResult.delete.cancel': 'Cancel',
  'pages.inspectionResult.status.approve': 'Approve',
  'pages.inspectionResult.status.reject': 'Reject',
  'pages.inspectionResult.judgementResult': 'Judgement Result',
  'pages.inspectionResult.judgementResult.required': 'Judgement Result is required',
  'pages.inspectionResult.judgementRemark': 'Judgement Remark',
  'pages.inspectionResult.mainInfo': 'Main Information',
  'pages.inspectionResult.qcDefinitionCode': 'QC Definition Code',
  'pages.inspectionResult.checklistCode': 'Checklist Code',
  'pages.inspectionResult.defectListCode': 'Defect List Code',
  'pages.inspectionResult.employeeName': 'Employee Name',
  'pages.inspectionResult.targetDate': 'Target Date',
  'pages.inspectionResult.totalDefect': 'Total Defect',
  'pages.inspectionResult.totalEquivalent': 'Total Equivalent',

  // Inspection Result - Export
  'pages.inspectionResult.export': 'Export',
  'pages.inspectionResult.selectReportTemplate': 'Select Report Template',

  // Report Docs
  'pages.reportDocs.templateDesign.title': 'Template Design Guide',
  'pages.reportDocs.templateDesign.description':
    'Detailed guide on how to design report templates and use placeholders for Inspection Result reports.',
  'pages.reportDocs.view': 'View',
  'pages.reportDocs.hide': 'Hide',
  'pages.reportDocs.placeholder': 'Select a document from the list to view its content.',
  
  // Inspection Result tabs
  'pages.inspectionResult.tabs.summaries': 'Summaries',
  'pages.inspectionResult.tabs.defectColorSizes': 'Defect Color Sizes',
  'pages.inspectionResult.tabs.checklists': 'Checklists',
  'pages.inspectionResult.tabs.defectCapturings': 'Defect Capturings',
  'pages.inspectionResult.tabs.finalJudgement': 'Final Judgement',
  
  // Inspection Result Summary
  'pages.inspectionResult.summary.product': 'Product',
  'pages.inspectionResult.summary.color': 'Color',
  'pages.inspectionResult.summary.size': 'Size',
  'pages.inspectionResult.summary.orderQuantity': 'Order Quantity',
  'pages.inspectionResult.summary.offeredQuantity': 'Offered Quantity',
  'pages.inspectionResult.summary.inspectedQuantity': 'Inspected Quantity',
  'pages.inspectionResult.summary.acceptanceQuantity': 'Acceptance Quantity',
  'pages.inspectionResult.summary.equilaventAcceptLimit': 'Equivalent Accept Limit',
  'pages.inspectionResult.summary.equivalentAcceptLimit': 'Equivalent Accept Limit',
  'pages.inspectionResult.summary.majorAcceptLimit': 'Major Accept Limit',
  'pages.inspectionResult.summary.minorAcceptLimit': 'Minor Accept Limit',
  'pages.inspectionResult.summary.fiDate': 'FI Date',
  
  // Inspection Result Final Judgement
  'pages.inspectionResult.finalJudgement.complete': 'Complete',
  'pages.inspectionResult.finalJudgement.approve': 'Approve',
  'pages.inspectionResult.finalJudgement.reject': 'Reject',
  'pages.inspectionResult.finalJudgement.cancel': 'Cancel',
  'pages.inspectionResult.finalJudgement.files': 'Attachments',
  'pages.inspectionResult.finalJudgement.file.manage': 'Manage Files',
  'pages.inspectionResult.finalJudgement.file.totalCount': 'Total Files: {count}',
  'pages.inspectionResult.finalJudgement.file.selectAll': 'Select All',
  'pages.inspectionResult.finalJudgement.file.downloadSelected': 'Download Selected',
  'pages.inspectionResult.finalJudgement.file.deleteSelected': 'Delete Selected',
  'pages.inspectionResult.finalJudgement.file.selectedCount': 'Selected: {count}',
  'pages.inspectionResult.finalJudgement.view.table': 'Table View',
  'pages.inspectionResult.finalJudgement.view.upload': 'Upload View',
  'pages.inspectionResult.finalJudgement.file.manageTitle': 'Final Judgement Files',
  'pages.inspectionResult.finalJudgement.file.upload': 'Upload',
  'pages.inspectionResult.finalJudgement.files.table': 'Final Judgement Files',
  'pages.inspectionResult.finalJudgement.file.name': 'Name',
  'pages.inspectionResult.finalJudgement.file.placeholder.name': 'Enter file name',
  'pages.inspectionResult.finalJudgement.file.required.name': 'Name is required',
  'pages.inspectionResult.finalJudgement.file.description': 'Description',
  'pages.inspectionResult.finalJudgement.file.placeholder.description': 'Enter description',
  'pages.inspectionResult.finalJudgement.file.actions': 'Actions',
  'pages.inspectionResult.finalJudgement.file.view': 'View',
  'pages.inspectionResult.finalJudgement.file.delete.confirm': 'Delete this file?',
  
  // Inspection Result Defect Color Size
  'pages.inspectionResult.defectColorSize.product': 'Product',
  'pages.inspectionResult.defectColorSize.color': 'Color',
  'pages.inspectionResult.defectColorSize.size': 'Size',
  'pages.inspectionResult.defectColorSize.status': 'Status',
  'pages.inspectionResult.defectColorSize.defectQuantity': 'Defect Quantity',
  'pages.inspectionResult.defectColorSize.bGroupQuantity': 'B Group Quantity',
  'pages.inspectionResult.defectColorSize.okQuantity': 'OK Quantity',
  'pages.inspectionResult.defectColorSize.confirm': 'Confirm',
  'pages.inspectionResult.defectColorSize.approve': 'Approve',
  'pages.inspectionResult.defectColorSize.reject': 'Reject',
  
  // Inspection Result Checklist
  'pages.inspectionResult.checklist.checklistId': 'Checklist',
  'pages.inspectionResult.checklist.result': 'Result',
  'pages.inspectionResult.checklist.status': 'Status',
  'pages.inspectionResult.checklist.confirm': 'Confirm',
  'pages.inspectionResult.checklist.approve': 'Approve',
  'pages.inspectionResult.checklist.reject': 'Reject',
  'pages.inspectionResult.checklistDetail.result': 'Result',
  'pages.inspectionResult.checklistDetail.name': 'Detail Name',
  'pages.inspectionResult.checklistDetail.standardValue': 'Standard Value',
  'pages.inspectionResult.checklistDetail.sampleSize': 'Sample Size',
  'pages.inspectionResult.checklistDetail.checkedBy': 'Checked By',
  'pages.inspectionResult.checklistDetail.checkedDate': 'Checked Date',
  'pages.inspectionResult.checklistDetail.comment': 'Comment',
  'pages.inspectionResult.checklistDetail.files': 'Files',
  'pages.inspectionResult.checklistDetail.files.manage': 'Files',
  'pages.inspectionResult.checklistDetail.files.table': 'File Attachments',
  'pages.inspectionResult.checklistDetail.file.name': 'Name',
  'pages.inspectionResult.checklistDetail.file.placeholder.name': 'Enter file name',
  'pages.inspectionResult.checklistDetail.file.description': 'Description',
  'pages.inspectionResult.checklistDetail.file.placeholder.description': 'Enter description',
  'pages.inspectionResult.checklistDetail.file.actions': 'Actions',
  'pages.inspectionResult.checklistDetail.file.view': 'View',
  'pages.inspectionResult.checklistDetail.file.upload': 'Upload',
  'pages.inspectionResult.checklistDetail.file.delete.confirm': 'Delete this file?',
  
  // Inspection Result Defect Capturing
  'pages.inspectionResult.defectCapturing.defectListId': 'Defect List',
  'pages.inspectionResult.defectCapturing.status': 'Status',
  'pages.inspectionResult.defectCapturing.confirm': 'Confirm',
  'pages.inspectionResult.defectCapturing.approve': 'Approve',
  'pages.inspectionResult.defectCapturing.reject': 'Reject',
  'pages.inspectionResult.defectCapturing.totalEquivalentCount': 'Total Equivalent Count',
  'pages.inspectionResult.defectCapturing.defectJudgementBySystem': 'System Judgement',
  'pages.inspectionResult.defectCapturing.defectJudgementByUser': 'User Judgement',
  'pages.inspectionResult.defectCapturingDetail.defectCode': 'Defect Code',
  'pages.inspectionResult.defectCapturingDetail.defectName': 'Defect Name',
  'pages.inspectionResult.defectCapturingDetail.minorCount': 'Minor',
  'pages.inspectionResult.defectCapturingDetail.majorCount': 'Major',
  'pages.inspectionResult.defectCapturingDetail.criticalCount': 'Critical',
  'pages.inspectionResult.defectCapturingDetail.files': 'Files',
  'pages.inspectionResult.defectCapturingDetail.files.manage': 'Files',
  'pages.inspectionResult.defectCapturingDetail.files.table': 'File Attachments',
  'pages.inspectionResult.defectCapturingDetail.file.name': 'Name',
  'pages.inspectionResult.defectCapturingDetail.file.placeholder.name': 'Enter file name',
  'pages.inspectionResult.defectCapturingDetail.file.description': 'Description',
  'pages.inspectionResult.defectCapturingDetail.file.placeholder.description': 'Enter description',
  'pages.inspectionResult.defectCapturingDetail.file.actions': 'Actions',
  'pages.inspectionResult.defectCapturingDetail.file.view': 'View',
  'pages.inspectionResult.defectCapturingDetail.file.upload': 'Upload',
  'pages.inspectionResult.defectCapturingDetail.file.delete.confirm': 'Delete this file?',
  'pages.inspectionResult.defectCapturingDetail.ncr': 'NCR',
  'pages.inspectionResult.defectCapturingDetail.ncr.manage': 'Manage NCR',
  'pages.inspectionResult.defectCapturingDetail.ncr.notFound': 'NCR not found',
  'pages.inspectionResult.defectCapturingDetail.ncr.code': 'Code',
  'pages.inspectionResult.defectCapturingDetail.ncr.status': 'Status',
  'pages.inspectionResult.defectCapturingDetail.ncr.defectReasonIds': 'Defect Reasons',
  'pages.inspectionResult.defectCapturingDetail.ncr.defectReasonIds.required': 'Defect Reasons is required',
  'pages.inspectionResult.defectCapturingDetail.ncr.defectActionIds': 'Defect Actions',
  'pages.inspectionResult.defectCapturingDetail.ncr.expectedCorrectiveDate': 'Expected Corrective Date',
  'pages.inspectionResult.defectCapturingDetail.ncr.correctivePersonId': 'Corrective Person',
  'pages.inspectionResult.defectCapturingDetail.ncr.description': 'Description',

  // Inspection Inline
  'pages.inspectionInline.code': 'Code',
  'pages.inspectionInline.date': 'Date',
  'pages.inspectionInline.status': 'Status',
  'pages.inspectionInline.sourceTransactionCode': 'Source Transaction',
  'pages.inspectionInline.operationLibraryDetailCode': 'Operation Library Detail',
  'pages.inspectionInline.employee': 'Employee',
  'pages.inspectionInline.employeeId': 'Employee',
  'pages.inspectionInline.company': 'Company',
  'pages.inspectionInline.companyId': 'Company',
  'pages.inspectionInline.site': 'Site',
  'pages.inspectionInline.siteId': 'Site',
  'pages.inspectionInline.qcDefinition': 'QC Definition',
  'pages.inspectionInline.qcDefinitionId': 'QC Definition',
  'pages.inspectionInline.defectList': 'Defect List',
  'pages.inspectionInline.defectListId': 'Defect List',
  'pages.inspectionInline.resolvedResult': 'Resolved Result',
  'pages.inspectionInline.userResult': 'User Result',
  'pages.inspectionInline.operationLibraryDetail': 'Operation Library Detail',
  'pages.inspectionInline.sourceTransaction': 'Source Transaction',
  'pages.inspectionInline.description': 'Description',
  'pages.inspectionInline.updatedAt': 'Updated At',
  'pages.inspectionInline.create': 'Add',
  'pages.inspectionInline.update': 'Update',
  'pages.inspectionInline.delete': 'Delete',
  'pages.inspectionInline.delete.confirm': 'Are you sure you want to delete the selected inspection inline(s)?',
  'pages.inspectionInline.actions': 'Actions',
  'pages.inspectionInline.selected': 'Selected {count} items',
  'pages.inspectionInline.unselect': 'Unselect',
  'pages.inspectionInline.selectMasters': 'Select Masters',
  'pages.inspectionInline.selectOperationLibraryDetail': 'Select Operation Library Detail (Select One)',
  'pages.inspectionInline.selectComponents': 'Select Components (Select Many)',
  'pages.inspectionInline.selectSourceTransaction': 'Select Source Transaction (Select One)',
  'pages.inspectionInline.title.create': 'Create Inspection Inline',
  'pages.inspectionInline.title.update': 'Update Inspection Inline',
  'pages.inspectionInline.mainInfo': 'Main Information',
  'pages.inspectionInline.systemResult': 'System Result',
  'pages.inspectionInline.tabs.defectColorSizes': 'Defect Color Sizes',
  'pages.inspectionInline.defectColorSize.component': 'Component',
  'pages.inspectionInline.defectColorSize.componentUom': 'Component UOM',
  'pages.inspectionInline.defectColorSize.color': 'Color',
  'pages.inspectionInline.defectColorSize.size': 'Size',
  'pages.inspectionInline.defectColorSize.plannedQuantity': 'Planned Quantity',
  'pages.inspectionInline.defectColorSize.outputQuantity': 'Output Quantity',
  'pages.inspectionInline.defectColorSize.okQuantity': 'OK Quantity',
  'pages.inspectionInline.defectColorSize.defectQuantity': 'Defect Quantity',
  'pages.inspectionInline.defectColorSize.bGroupQuantity': 'B Group Quantity',
  'pages.inspectionInline.tabs.defectCapturings': 'Defect Capturings',
  'pages.inspectionInline.defectCapturing.defectListDetail': 'Defect List Detail',
  'pages.inspectionInline.defectCapturing.defectCode': 'Defect Code',
  'pages.inspectionInline.defectCapturing.defectName': 'Defect Name',
  'pages.inspectionInline.defectCapturing.majorCount': 'Major',
  'pages.inspectionInline.defectCapturing.minorCount': 'Minor',
  'pages.inspectionInline.defectCapturing.criticalCount': 'Critical',
  'pages.inspectionInline.defectCapturing.description': 'Description',
  'pages.inspectionInline.defectCapturing.totalDefect': 'Total Defect',
  'pages.inspectionInline.defectCapturing.totalEquivalent': 'Total Equivalent',
  'pages.inspectionInline.defectCapturing.files': 'Files',
  'pages.inspectionInline.defectCapturing.files.view': 'View',
  'pages.inspectionInline.defectCapturing.files.manage': 'Manage Files',
  'pages.inspectionInline.defectCapturing.files.view.table': 'Switch to Table View',
  'pages.inspectionInline.defectCapturing.files.view.upload': 'Switch to Upload View',
  'pages.inspectionInline.defectCapturing.files.title': 'Defect Capturing Files',
  'pages.inspectionInline.defectCapturing.files.table': 'File Attachments',
  'pages.inspectionInline.defectCapturing.files.noRecord': 'No record selected',
  'pages.inspectionInline.defectCapturing.files.name': 'Name',
  'pages.inspectionInline.defectCapturing.files.placeholder.name': 'Enter file name',
  'pages.inspectionInline.defectCapturing.files.description': 'Description',
  'pages.inspectionInline.defectCapturing.files.placeholder.description': 'Enter description',
  'pages.inspectionInline.defectCapturing.files.actions': 'Actions',
  'pages.inspectionInline.defectCapturing.files.upload': 'Upload',
  'pages.inspectionInline.defectCapturing.files.delete.confirm': 'Delete this file?',
  'pages.inspectionInline.placeholder.operationLibraryDetail': 'Select Operation Library Detail',
  'pages.inspectionInline.placeholder.components': 'Select Components',

  // Checklist
  'pages.checklist.code': 'Code',
  'pages.checklist.name': 'Name',
  'pages.checklist.description': 'Description',
  'pages.checklist.isActive': 'Active',
  'pages.checklist.updatedAt': 'Updated At',
  'pages.checklist.actions': 'Actions',
  'pages.checklist.create': 'Create',
  'pages.checklist.update': 'Update',
  'pages.checklist.delete': 'Delete',
  'pages.checklist.cancel': 'Cancel',
  'pages.checklist.close': 'Close',
  'pages.checklist.details': 'Details',
  'pages.checklist.createForm.title': 'New Checklist',
  'pages.checklist.updateForm.title': 'Update Checklist',
  'pages.checklist.delete.confirm': 'Are you sure you want to delete this item?',
  'pages.checklist.placeholder.description': 'Enter description',
  'pages.checklist.detailsTable': 'Details',
  'pages.checklist.detail.name': 'Name',
  'pages.checklist.detail.placeholder.name': 'Enter name',
  'pages.checklist.detail.standardValue': 'Standard',
  'pages.checklist.detail.placeholder.standard': 'Enter standard',
  'pages.checklist.detail.sampleSize': 'Sample Size',
  'pages.checklist.detail.placeholder.sampleSize': 'Enter sample size',
  'pages.checklist.detail.description': 'Description',
  'pages.checklist.detail.placeholder.description': 'Enter description',
  'pages.checklist.detail.files': 'Files',
  'pages.checklist.detail.addChild': 'Add child',
  'pages.checklist.detail.delete.confirm': 'Delete this item?',
  'pages.checklist.detail.validation.nameRequired': '{count} checklist detail(s) are missing required name field',
  'pages.checklist.detail.files.manage': 'Manage Files',
  'pages.checklist.detail.files.table': 'File Attachments',
  'pages.checklist.detail.files.noRecord': 'No record selected',
  'pages.checklist.detail.file.name': 'Name',
  'pages.checklist.detail.file.placeholder.name': 'Enter file name',
  'pages.checklist.detail.file.description': 'Description',
  'pages.checklist.detail.file.placeholder.description': 'Enter description',
  'pages.checklist.detail.file.actions': 'Actions',
  'pages.checklist.detail.file.view': 'View',
  'pages.checklist.detail.file.upload': 'Upload',
  'pages.checklist.detail.file.delete.confirm': 'Delete this file?',
  'pages.checklist.detail.file.switchToTable': 'Table View',
  'pages.checklist.detail.file.switchToUpload': 'Upload View',
  'pages.checklist.detail.file.selectAll': 'Select All',
  'pages.checklist.detail.file.downloadSelected': 'Download',
  'pages.checklist.detail.file.deleteSelected': 'Delete',
  'pages.checklist.detail.file.download': 'Download',
  'pages.checklist.detail.file.delete': 'Delete',
  
  // Mapping
  'pages.mapping.code': 'Code',
  'pages.mapping.name': 'Name',
  'pages.mapping.type': 'Type',
  'pages.mapping.refereceId': 'Reference',
  'pages.mapping.productId': 'Product',
  'pages.mapping.productGroupId': 'Product Group',
  'pages.mapping.categoryId': 'Category',
  'pages.mapping.customerId': 'Customer',
  'pages.mapping.supplierId': 'Supplier',
  'pages.mapping.processId': 'Operation Library Detail',
  'pages.mapping.countryId': 'Country',
  'pages.mapping.marketId': 'Market',
  'pages.mapping.destinationId': 'Destination',
  'pages.mapping.isActive': 'Active',
  'pages.mapping.updatedAt': 'Updated At',
  'pages.mapping.selected': 'Selected {count} items',
  'pages.mapping.unselect': 'Unselect',
  'pages.mapping.add': 'Add',
  'pages.mapping.update': 'Update',
  'pages.mapping.drawer.add': 'Add Mapping',
  'pages.mapping.drawer.update': 'Update Mapping',
  'pages.mapping.cancel': 'Cancel',
  'pages.mapping.close': 'Close',
  'pages.mapping.save': 'Save',
  'pages.mapping.table.title': 'Mapping Records',
  'pages.mapping.addRows': 'Add Rows',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.uploading': 'Uploading...',
  'common.popup.blocked': 'Please allow pop-ups to open this file.',
  'common.selectAll': 'Select All',
  'common.download': 'Download',
  'common.delete': 'Delete',
};
